module.exports = __webpack_public_path__ + "static/media/dcc2412-30a.8b56ecb9.jpg";